export enum TestCasesEnum {
    MODULE_ACCESS = 'View',
    IMPORT = 'Import',
    UPDATE = 'Update',
}